import { render, staticRenderFns } from "./SchoolManagement.vue?vue&type=template&id=d245774e&scoped=true&"
import script from "./SchoolManagement.vue?vue&type=script&lang=js&"
export * from "./SchoolManagement.vue?vue&type=script&lang=js&"
import style0 from "./SchoolManagement.vue?vue&type=style&index=0&id=d245774e&lang=scss&scoped=true&"
import style1 from "./SchoolManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d245774e",
  null
  
)

export default component.exports